import { css } from "@emotion/css";
import React, { CSSProperties } from "react";
import { TextFieldProps } from "react-aria-components";

import { _TextArea } from "./assets/_TextArea";
import { _Text } from "../../_assets/_Text";
import {
  FieldErrorsProps,
  FieldErrors,
} from "../_assets/input-wrapper/FieldErrors";
import { FormFeedbackRAC } from "../_assets/input-wrapper/FormFeedbackRAC";
import { FormLabelRAC } from "../_assets/input-wrapper/FormLabelRAC";
import { _TextField } from "../text-field/assets/_TextField";
import { LabelAlign } from "../../types";
import { cssToken } from "@certn/cascadia/utils";
import { CascadiaColor } from "packages/cascadia-tokens";

export interface TextAreaProps extends Omit<TextFieldProps, "children"> {
  label?: string;
  testID: string;
  placeholder?: string;
  description?: string;
  errors?: FieldErrorsProps["children"];
  successMessage?: string;
  resize?: CSSProperties["resize"];
  info?: React.ReactNode;
  isBlurred?: boolean;
  minHeight?: number | string;
  labelAlign?: LabelAlign;
  backgroundColor?: CascadiaColor;
}

export function TextArea(props: TextAreaProps) {
  const { label, placeholder, description } = props;

  return (
    <_TextField {...props}>
      <FormLabelRAC isRequired={props.isRequired} info={props.info}>
        {label}
      </FormLabelRAC>
      <_TextArea
        data-testid={props.testID}
        placeholder={placeholder}
        className={css({
          resize: props.resize,
          minHeight: props.minHeight,
          height: props.minHeight,
          backgroundColor: cssToken(props.backgroundColor),
        })}
      />
      {(description || props.maxLength) && (
        <div
          className={css({
            display: "flex",
            justifyContent: description ? "space-between" : "end",
            alignItems: "center",
          })}
        >
          {description && (
            <_Text style="input/helper" color="text-weak" slot="description">
              {description}
            </_Text>
          )}
          {props.maxLength && (
            <div>
              <_Text style="input/helper" color="text-weak">
                {`${props.value?.length ?? 0}/${props.maxLength}`}
              </_Text>
            </div>
          )}
        </div>
      )}

      <FieldErrors>{props.errors}</FieldErrors>
      <FormFeedbackRAC type="valid">{props.successMessage}</FormFeedbackRAC>
    </_TextField>
  );
}
